module.exports = __webpack_public_path__ + "files/28ea5365eb1588d21cf5d7815ca1a9ad.png";